/* eslint-disable */
/* tslint:disable */
// This file is auto-generated by `yarn swagger-gen`. Do not edit by hand.
// Source: src/api/v2.ts
//
// Aliases applied (see scripts/swagger-constraints-aliases.ts):
//   AddContainerImageAsset.asset_name                    → Asset.name
//   AddImportedImageAsset.asset_name                     → Asset.name
//   AddSbomAsset.asset_name                              → Asset.name
//   AppVersionVulnerabilityAnnotation.action_statement   → VulnerabilityAnnotation.action_statement
//   AppVersionVulnerabilityAnnotation.additional_details → VulnerabilityAnnotation.additional_details
//   AppVersionVulnerabilityAnnotation.impact_statement   → VulnerabilityAnnotation.impact_statement
//   AppVersionVulnerabilityAnnotation.status_notes       → VulnerabilityAnnotation.status_notes
//   ContactInfoUpdate.name                               → ContactInfo.name
//   ContactInfoUpdate.phone                              → ContactInfo.phone

// ---------------------------------------------------------------------------
// AccountCreation
// ---------------------------------------------------------------------------

export const ACCOUNT_CREATION_EMAIL_PATTERN =
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
export const ACCOUNT_CREATION_NAME_PATTERN =
  /^[a-zA-Z0-9][ a-zA-Z0-9@.!$+=^_`~;-]{1,126}[a-zA-Z0-9_]$/;

// ---------------------------------------------------------------------------
// AccountInfo
// ---------------------------------------------------------------------------

export const ACCOUNT_INFO_EMAIL_PATTERN =
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

// ---------------------------------------------------------------------------
// AddContainerImageAsset
// ---------------------------------------------------------------------------

export const ADD_CONTAINER_IMAGE_ASSET_IMAGE_REFERENCE_MAX_LENGTH = 512;
export const ADD_CONTAINER_IMAGE_ASSET_IMAGE_REFERENCE_MIN_LENGTH = 1;
export const ADD_CONTAINER_IMAGE_ASSET_IMAGE_REFERENCE_PATTERN =
  /^[\x21-\x7e]+$/;

// ---------------------------------------------------------------------------
// AddImportedImageAsset
// ---------------------------------------------------------------------------

export const ADD_IMPORTED_IMAGE_ASSET_IMAGE_REFERENCE_MAX_LENGTH = 512;
export const ADD_IMPORTED_IMAGE_ASSET_IMAGE_REFERENCE_MIN_LENGTH = 1;
export const ADD_IMPORTED_IMAGE_ASSET_IMAGE_REFERENCE_PATTERN =
  /^[\x21-\x7e]+$/;

// ---------------------------------------------------------------------------
// AnalysisArchiveSource
// ---------------------------------------------------------------------------

export const ANALYSIS_ARCHIVE_SOURCE_DIGEST_PATTERN =
  /^sha256:[a-fA-F0-9]{64}$/;

// ---------------------------------------------------------------------------
// App
// ---------------------------------------------------------------------------

export const APP_DESCRIPTION_MAX_LENGTH = 2000;
export const APP_DESCRIPTION_PATTERN = /^[^\x00-\x08\x0b\x0c\x0e-\x1f\x7f]*$/;
export const APP_NAME_MAX_LENGTH = 256;
export const APP_NAME_MIN_LENGTH = 1;
export const APP_NAME_PATTERN = /^[^\x00-\x1f\x7f<>]+$/;

// ---------------------------------------------------------------------------
// AppVersion
// ---------------------------------------------------------------------------

export const APP_VERSION_DESCRIPTION_MAX_LENGTH = 2000;
export const APP_VERSION_DESCRIPTION_PATTERN =
  /^[^\x00-\x08\x0b\x0c\x0e-\x1f\x7f]*$/;
export const APP_VERSION_NAME_MAX_LENGTH = 256;
export const APP_VERSION_NAME_MIN_LENGTH = 1;
export const APP_VERSION_NAME_PATTERN = /^[^\x00-\x1f\x7f<>]+$/;

// ---------------------------------------------------------------------------
// AppVersionVulnerabilityAnnotation
// ---------------------------------------------------------------------------

export const APP_VERSION_VULNERABILITY_ANNOTATION_VULNERABILITY_ID_MAX_LENGTH = 64;
export const APP_VERSION_VULNERABILITY_ANNOTATION_VULNERABILITY_ID_MIN_LENGTH = 1;
export const APP_VERSION_VULNERABILITY_ANNOTATION_VULNERABILITY_ID_PATTERN =
  /^[A-Za-z0-9][A-Za-z0-9.:\-_/]*$/;

// ---------------------------------------------------------------------------
// Asset
// ---------------------------------------------------------------------------

export const ASSET_NAME_MAX_LENGTH = 256;
export const ASSET_NAME_MIN_LENGTH = 1;
export const ASSET_NAME_PATTERN = /^[^\x00-\x1f\x7f<>]+$/;

// ---------------------------------------------------------------------------
// ContactInfo
// ---------------------------------------------------------------------------

export const CONTACT_INFO_EMAIL_MAX_LENGTH = 254;
export const CONTACT_INFO_NAME_MAX_LENGTH = 256;
export const CONTACT_INFO_NAME_MIN_LENGTH = 1;
export const CONTACT_INFO_NAME_PATTERN = /^[^\x00-\x1f\x7f<>]+$/;
export const CONTACT_INFO_PHONE_MAX_LENGTH = 50;

// ---------------------------------------------------------------------------
// KubernetesInventoryContainer
// ---------------------------------------------------------------------------

export const KUBERNETES_INVENTORY_CONTAINER_IMAGE_TAG_PATTERN = /^(?!\s*$).+/;

// ---------------------------------------------------------------------------
// NotificationEventSelector
// ---------------------------------------------------------------------------

export const NOTIFICATION_EVENT_SELECTOR_TYPE_PATTERN = /^[a-z0-9-_.*]+$/;

// ---------------------------------------------------------------------------
// Policy
// ---------------------------------------------------------------------------

export const POLICY_NAME_MIN_LENGTH = 1;

// ---------------------------------------------------------------------------
// RbacManagerSamlConfiguration
// ---------------------------------------------------------------------------

export const RBAC_MANAGER_SAML_CONFIGURATION_NAME_PATTERN = /^[a-zA-Z0-9_-]+$/;

// ---------------------------------------------------------------------------
// RegistryDigestSource
// ---------------------------------------------------------------------------

export const REGISTRY_DIGEST_SOURCE_DOCKERFILE_PATTERN = /^[a-zA-Z0-9+/=]+$/;

// ---------------------------------------------------------------------------
// RegistryTagSource
// ---------------------------------------------------------------------------

export const REGISTRY_TAG_SOURCE_DOCKERFILE_PATTERN = /^[a-zA-Z0-9+/=]+$/;

// ---------------------------------------------------------------------------
// Scan
// ---------------------------------------------------------------------------

export const SCAN_DOCKERFILE_PATTERN = /^[a-zA-Z0-9+/=]+$/;

// ---------------------------------------------------------------------------
// UserApiKey
// ---------------------------------------------------------------------------

export const USER_API_KEY_EXPIRES_AT_PATTERN =
  /^[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}Z$/;

// ---------------------------------------------------------------------------
// UserCreation
// ---------------------------------------------------------------------------

export const USER_CREATION_PASSWORD_PATTERN = /.{6,128}$/;
export const USER_CREATION_USERNAME_PATTERN =
  /^[a-zA-Z0-9][ a-zA-Z0-9@.!#$+=^_`~;:-]{1,126}[a-zA-Z0-9_]$/;

// ---------------------------------------------------------------------------
// UserGroup
// ---------------------------------------------------------------------------

export const USER_GROUP_NAME_PATTERN =
  /^[a-zA-Z0-9][ a-zA-Z0-9@.!#$+=^_`~;-]{1,126}[a-zA-Z0-9_]$/;

// ---------------------------------------------------------------------------
// UserGroupPost
// ---------------------------------------------------------------------------

export const USER_GROUP_POST_NAME_PATTERN =
  /^[a-zA-Z0-9][ a-zA-Z0-9@.!#$+=^_`~;-]{1,126}[a-zA-Z0-9_]$/;

// ---------------------------------------------------------------------------
// VulnerabilityAnnotation
// ---------------------------------------------------------------------------

export const VULNERABILITY_ANNOTATION_ACTION_STATEMENT_MAX_LENGTH = 8192;
export const VULNERABILITY_ANNOTATION_ACTION_STATEMENT_PATTERN =
  /^[^\x00-\x08\x0b\x0c\x0e-\x1f\x7f]*$/;
export const VULNERABILITY_ANNOTATION_ADDITIONAL_DETAILS_MAX_LENGTH = 8192;
export const VULNERABILITY_ANNOTATION_ADDITIONAL_DETAILS_PATTERN =
  /^[^\x00-\x08\x0b\x0c\x0e-\x1f\x7f]*$/;
export const VULNERABILITY_ANNOTATION_IMPACT_STATEMENT_MAX_LENGTH = 8192;
export const VULNERABILITY_ANNOTATION_IMPACT_STATEMENT_PATTERN =
  /^[^\x00-\x08\x0b\x0c\x0e-\x1f\x7f]*$/;
export const VULNERABILITY_ANNOTATION_STATUS_NOTES_MAX_LENGTH = 8192;
export const VULNERABILITY_ANNOTATION_STATUS_NOTES_PATTERN =
  /^[^\x00-\x08\x0b\x0c\x0e-\x1f\x7f]*$/;
